import React from "react";
import Slider from "react-slick";
import { bool, number, arrayOf, shape, func } from "prop-types";
import * as i18nUtils from "util/i18n";
import { addUtcOffset } from "util/date";
import Button from "pages/_components/Button";
import Image from "pages/_components/Image";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";

const CarouselMultiItems = ({ items, itemsPerPage, isDesktop, handleOnClick }) => {
    const itemWidth = isDesktop ? `calc(50vw / ${itemsPerPage} - 10px)` : "300px";
    const dataWidth = isDesktop ? `calc(50vw / ${itemsPerPage} - 30px)` : "280px";

    const onClickItem = (value) => {
        if (handleOnClick) {
            handleOnClick(value);
        }
    }

    const renderItem = (item) => (
        <div style={{ display: "flex", flexDirection: "row" }} onClick={() => onClickItem(item)}>
            <div
                key={item.id}
                className="carousel-item"
                style={{
                    width: itemWidth,
                }}>
                <div
                    className="item-data"
                    style={{
                        width: dataWidth,
                    }}>
                    <p className="item-title">{item.entityName.toUpperCase()}</p>
                    <p className="item-text">{item.alias || ""}</p>
                    <p className="item-text">{item.codeLink}</p>
                    <div className="item-text">
                        <FormattedDate date={addUtcOffset(item.dueDate)} dateFormat="DD/MM/YYYY" />
                    </div>

                    <FormattedAmount currency="ARS" quantity={item.amount} />
                </div>

                <div className="item-icon">
                    <Image src="images/rightArrow.svg" className="svg-icon" />
                </div>
            </div>
        </div>
    );
    const ArrowLeft = (props) => (
        <Button
            {...props}
            image="images/figma/icon/arrow-left-filled.svg"
            bsStyle="btn-rotate"
            aria-label={i18nUtils.get("Anterior")}
        />
    );
    const ArrowRight = (props) => (
        <Button
            {...props}
            image="images/figma/icon/arrow-right-filled.svg"
            bsStyle="btn-rotate"
            aria-label={i18nUtils.get("Siguiente")}
        />
    );

    const settings = {
        draggable: true,
        infinite: false,
        initialSlide: 0,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        ...(items.length > 2 && {
            dots: true,
            nextArrow: <ArrowRight />,
            prevArrow: <ArrowLeft />,
        }),
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: itemsPerPage,
                    slidesToScroll: itemsPerPage,
                    initialSlide: 0,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    arrows: false,
                    initialSlide: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return <Slider {...settings}>{items.map((item) => renderItem(item))}</Slider>;
};

CarouselMultiItems.propTypes = {
    isDesktop: bool.isRequired,
    items: arrayOf(shape({})).isRequired,
    itemsPerPage: number.isRequired,
    handleOnClick: func,
};

CarouselMultiItems.defaultProps = {
    handleOnClick: null,
}

export default CarouselMultiItems;
